module.exports = __webpack_public_path__ + "media/images/march8/march8-template-az-0d52a2ad6e8488eee30d572e7bf081c6.png";